import React from "react";
import { productBrandsMappingsApi } from "@/apis/apis";
import { columns } from "./Columns";
import MappingBaseTable from "../BaseTable";
import ProductBrandModal from "@/Modals/WebDataManagement/Mapping/ProductBrand/Modal";
import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/Mapping/BaseImport/baseImportData";

export default function ProductBrandPage() {
  return (
    <MappingBaseTable
      label="Product - Brand"
      apiURL={productBrandsMappingsApi}
      columns={columns()}
      ModalComponent={ProductBrandModal}
      importData={BASE_IMPORT_DATA.PRODUCT_BRAND}
      enableAdd={false}
      enableEdit={true}
      enableDelete={false}
    />
  );
}
